module.exports = __webpack_public_path__ + "img/left-arrow.89472dc7.svg";